import React from 'react';
import { IProps } from './types';
import * as Styled from './styles';

export const ExpandButton: React.FC<IProps> = ({ expandContent }) => (
  <Styled.Wrapper className="accordion-box-button-wrapper">
    <Styled.Button onClick={expandContent} className="accordion-box-expand-button">
      Ver Mais
    </Styled.Button>
  </Styled.Wrapper>
);

export default ExpandButton;
